import AiDraftBanner from './AiDraftBanner.component';

export default AiDraftBanner;
export { AI_DRAFT_BANNER_STEP } from './utils';
